import IntegracaoAmazonService from "@/services/IntegracaoAmazonService";

export const integracaoAmazon = {
  namespaced: true,
  state: {},
  actions: {
    getAuthorizationUrl() {
      return IntegracaoAmazonService.GetAuthorizationUrl().then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    refreshToken() {
      return IntegracaoAmazonService.RefreshToken().then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    disconnect() {
      return IntegracaoAmazonService.Disconnect().then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    updateNfeAutomatica(context, enabled) {
      return IntegracaoAmazonService.UpdateNfeAutomatica(enabled).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    exportProducts(context, payload) {
      return IntegracaoAmazonService.ExportProducts(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    importProducts() {
      return IntegracaoAmazonService.ImportProducts().then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
  },
  mutations: {},
};

export default integracaoAmazon;
